import * as React from "react";
import { useReducer } from "react";
import { draggableReducer, getInitialState, type ActionTypes } from "./reducers";

import type { DraggableContextState } from "./reducers";
const DraggableContext = React.createContext<DraggableProviderContext | null>(null);

export type DraggableProviderContext = {
    state: DraggableContextState;
    dispatch: React.Dispatch<ActionTypes>;
};

type Props = {
    children: React.ReactNode;
};

const DraggableProvider = ({ children }: Props) => {
    const [state, dispatch] = useReducer(draggableReducer, getInitialState());
    const value: DraggableProviderContext = { state, dispatch };
    return <DraggableContext.Provider value={value}>{children}</DraggableContext.Provider>;
};

const DraggableConsumer = DraggableContext.Consumer;

export { DraggableProvider, DraggableConsumer };
